<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-form :inline="true">
      <el-form-item label="商品名称">
        <el-input v-model="query.name" placeholder="输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="query.type">
          <el-option
            v-for="(item, i) in typeList"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status">
          <el-option
            v-for="(item, i) in statusList"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #name="{ row }">
        <div>{{ row.name }}<i @click="copyText(row)" class="el-icon-share share"></i></div>
      </template>
      <template #type="{ row }">
        <div>{{ $getLabel(typeList, row.type) }}</div>
      </template>
      <template #ilk="{ row }">
        <div>{{ $getLabel(ilkList, row.ilk) }}</div>
      </template>
      <template #status="{ row }">
        <el-tag type="info" v-if="row.status === 0">待上架</el-tag>
        <el-tag type="success" v-if="row.status === 1">上架中</el-tag>
        <el-tag type="warning" v-if="row.status === 2">已下架</el-tag>
      </template>
      <template #promotion="{ row }">
        <div v-if="row.rule_config">
          <el-tag type="success" size="small" v-if="getPromotionStatus(row)">有促销</el-tag>
          <el-tag type="info" size="small" v-else>无促销</el-tag>
          <el-popover
            placement="top"
            trigger="hover"
            width="300"
            v-if="getPromotionStatus(row)"
          >
            <div class="promotion-detail">
              <div v-for="(rule, index) in getPromotionRules(row)" :key="index" style="margin: 5px 0;">
                购买{{ rule.quantity }}个：{{ formatDiscount(rule.discount) }}
              </div>
            </div>
            <el-button slot="reference" type="text" size="small">查看详情</el-button>
          </el-popover>
        </div>
        <el-tag type="info" size="small" v-else>无促销</el-tag>
      </template>
      <template #handle="{ row }">
        <div v-if="row.type != 'consume'">
          <el-button size="small" type="primary" @click="update(row)"
            >编辑</el-button
          >
          <el-button
            size="small"
            v-if="row.status != 1"
            type="success"
            @click="updateStatus(row, 1)"
            >上架</el-button
          >
          <el-button
            size="small"
            v-if="row.status === 1"
            type="warning"
            @click="updateStatus(row, 2)"
            >下架</el-button
          >

          <el-popover
            placement="bottom"
            title="支付方式"
            width="300"
            trigger="click"
          >
          <div>
            <div>
              购买链接：
            </div>
            <div>
              {{getUrl(row)}}
            </div>
            <div>
              联营社购买链接：
            </div>
             <el-radio-group v-model="way">
              <el-radio label="buy">购买</el-radio>
              <el-radio label="dep">押金</el-radio>
            </el-radio-group>
              <el-button size="small" @click="openSharePop(row)" type="primary"
              >生成联营社码</el-button
            >
          </div>
           
            <el-button size="small" type="primary" slot="reference"
              >二维码</el-button
            >
          </el-popover>
        </div>
      </template>
    </auto-table>

   <shareCode ref="code"></shareCode>
  </div>
</template>

<script>
import shareCode from "../outSchool/components/mechanism/shareCode.vue";
import { typeList, statusList, ilkList } from "./components/type.js";
export default {
  components: {
    shareCode,
  },
  data() {
    return {
      nav: { firstNav: "商品管理", secondNav: "商品列表" },
      DataList: [],
      query: {
        name: "",
        type: "",
      },
      typeList: typeList,
      ilkList: ilkList,
      statusList: statusList,
      Option: [
        { name: "名称", value: "name", type: "custom" },
        { name: "售价", value: "min_price" },
        { name: "类型", value: "type", type: "custom" },
        { name: "已售", value: "sale_num" },
        { name: "状态", value: "status", type: "custom" },
        { name: "促销规则", value: "promotion", type: "custom" },
        { name: "上架模块", value: "ilk", type: "custom" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom", width: "300px" },
      ],
      Total: 0,
      way: "buy",
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    getPromotionStatus(row) {
      if (!row.rule_config) return false;
      try {
        const config = typeof row.rule_config === 'string' 
          ? JSON.parse(row.rule_config) 
          : row.rule_config;
        return config.enable_promotion && config.rules && config.rules.length > 0;
      } catch (e) {
        return false;
      }
    },
    getPromotionRules(row) {
      if (!row.rule_config) return [];
      try {
        const config = typeof row.rule_config === 'string' 
          ? JSON.parse(row.rule_config) 
          : row.rule_config;
        return config.rules || [];
      } catch (e) {
        return [];
      }
    },
    formatDiscount(discount) {
      return (discount * 10).toFixed(1) + '折';
    },
    getUrl(row){
      return 'https://joingroup.huihejituan.com/#/product/'+row.id;
    },
     async copyText(row){
      let url = 'https://joingroup.huihejituan.com/#/product/'+row.id;
        await navigator.clipboard.writeText(url);  
        this.$message('复制成功')
    },
    openSharePop(row) {
       let query = `id=${row.id}`
       let title = row.name
      if(this.way == 'dep'){
         query = `id=${row.id}&way=dep`
         title += '-押金'
      }

     
      let p = {
        platform: "mechanism_mp",
        page: 'subpackages/service/product/productDetails',
        scene: query,
        title: title,
      };
      this.$refs.code.openShare(p);
    },
    updateStatus(row, status) {
      this.$axios({
        url: "/user/product/update",
        method: "post",
        data: {
          id: row.id,
          status,
        },
      }).then((res) => {
        this.getList(1);
      });
    },

    add() {
      this.$router.push({ name: "createProduct" });
    },
    update(row) {
      this.$router.push({ name: "createProduct", query: { id: row.id } });
    },

    //记录
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/product/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          name: this.query.name || null,
          status: this.query.status,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.share{
  color: rgb(62, 136, 206);
}
.promotion-detail {
  max-height: 200px;
  overflow-y: auto;
}
</style>